'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.getChainSuggest = void 0;
var _toConsumableArray2 = _interopRequireDefault(require('@babel/runtime/helpers/toConsumableArray'));
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
function ownKeys(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r &&
			(o = o.filter(function (r) {
				return Object.getOwnPropertyDescriptor(e, r).enumerable;
			})),
			t.push.apply(t, o);
	}
	return t;
}
function _objectSpread(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2
			? ownKeys(Object(t), !0).forEach(function (r) {
					(0, _defineProperty2['default'])(e, r, t[r]);
			  })
			: Object.getOwnPropertyDescriptors
			? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
			: ownKeys(Object(t)).forEach(function (r) {
					Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
			  });
	}
	return e;
}
var DEFAULT_CHAIN_INFO = {
	chainName: 'Sei',
	chainId: 'pacific-1',
	restUrl: 'https://rest.wallet.pacific-1.sei.io/',
	rpcUrl: 'https://rpc.wallet.pacific-1.sei.io/',
	gasPriceStep: {
		low: 0.1,
		average: 0.2,
		high: 0.3
	}
};
var getChainSuggest = (exports.getChainSuggest = function getChainSuggest() {
	var chainInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var currencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var prefix = 'sei';
	var _DEFAULT_CHAIN_INFO$c = _objectSpread(_objectSpread({}, DEFAULT_CHAIN_INFO), chainInfo),
		chainId = _DEFAULT_CHAIN_INFO$c.chainId,
		chainName = _DEFAULT_CHAIN_INFO$c.chainName,
		rpcUrl = _DEFAULT_CHAIN_INFO$c.rpcUrl,
		restUrl = _DEFAULT_CHAIN_INFO$c.restUrl,
		gasPriceStep = _DEFAULT_CHAIN_INFO$c.gasPriceStep;
	return {
		chainId: chainId,
		chainName: chainName,
		rpc: rpcUrl,
		rest: restUrl,
		bip44: {
			coinType: 118
		},
		bech32Config: {
			bech32PrefixAccAddr: prefix,
			bech32PrefixAccPub: ''.concat(prefix, 'pub'),
			bech32PrefixValAddr: ''.concat(prefix, 'valoper'),
			bech32PrefixValPub: ''.concat(prefix, 'valoperpub'),
			bech32PrefixConsAddr: ''.concat(prefix, 'valcons'),
			bech32PrefixConsPub: ''.concat(prefix, 'valconspub')
		},
		currencies: [
			{
				coinDenom: 'SEI',
				coinMinimalDenom: 'usei',
				coinDecimals: 6
			}
		].concat((0, _toConsumableArray2['default'])(currencies)),
		feeCurrencies: [
			{
				coinDenom: 'SEI',
				coinMinimalDenom: 'usei',
				coinDecimals: 6,
				gasPriceStep: gasPriceStep
			}
		],
		stakeCurrency: {
			coinDenom: 'SEI',
			coinMinimalDenom: 'usei',
			coinDecimals: 6
		},
		coinType: 118,
		features: ['stargate', 'ibc-transfer', 'cosmwasm']
	};
});
//# sourceMappingURL=utils.js.map
